import { t } from 'i18next';

const Invoice3Table2 = ({ heading, rows, initialStock, total = {}, restStock = {} }) => {
  return (
    <table
      style={{
        width: '18%',
        borderCollapse: 'collapse',
        marginTop: '1mm',
        textAlign: 'center',
      }}
    >
      <thead>
        <tr
          style={{
            backgroundColor: '#0053a6',
            color: 'white',
          }}
        >
          <th
            style={{
              border: '0.3mm solid black',
              paddingBottom: '2.5mm',
              paddingTop: 0,
              textAlign: 'center',
            }}
            colSpan={3}
          >
            {t(`inventoryPage.${heading}`).toUpperCase()}
          </th>
        </tr>
        <tr style={{ width: '100%', backgroundColor: '#d4d4a4' }}>
          <th
            style={{
              border: '0.3mm solid black',
              padding: '0 1mm 2mm 1mm',
              fontSize: '3.6mm',
            }}
            colSpan={1}
          >
            APPRO
          </th>
          <th
            style={{
              border: '0.3mm solid black',
              padding: '0 1mm 2mm 1mm',
              fontSize: '3.6mm',
            }}
            colSpan={rows.length === 0 && restStock.rest ? 2 : 1}
          >
            DSTKG
          </th>
          {!(rows.length === 0 && restStock.rest) && (
            <th
              style={{
                border: '0.3mm solid black',
                padding: '0 1mm 2mm 1mm',
                fontSize: '3.6mm',
              }}
              colSpan={1}
            >
              EOD
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        {typeof total.totalSub !== 'number' && (
          <tr style={{ height: '4mm' }}>
            <td
              style={{
                border: '0.3mm solid black',
                paddingBottom: '1mm',
                paddingTop: 0,
              }}
            >
              {initialStock}
            </td>
            <td
              style={{
                border: '0.3mm solid black',
                paddingBottom: '1mm',
                paddingTop: 0,
              }}
            >
              {' '}
            </td>
            <td
              style={{
                border: '0.3mm solid black',
                paddingBottom: '1mm',
                paddingTop: 0,
              }}
            >
              {' '}
            </td>
          </tr>
        )}
        {rows.map((item, index) => {
          return (
            <tr key={index} style={{ height: '8mm' }}>
              <td
                style={{
                  border: '0.3mm solid black',
                  paddingBottom: '1mm',
                  paddingTop: 0,
                }}
              >
                {heading === 'cement'
                  ? item.totalCementAdd != null
                    ? item.totalCementAdd
                    : '-'
                  : heading === 'sand'
                    ? item.totalSandAdd != null
                      ? item.totalSandAdd
                      : '-'
                    : heading === 'gravel815'
                      ? item.totalGravel815Add != null
                        ? item.totalGravel815Add
                        : '-'
                      : item.totalGrave1525Add != null
                        ? item.totalGrave1525Add
                        : '-'}
              </td>
              <td
                style={{
                  border: '0.3mm solid black',
                  paddingBottom: '1mm',
                  paddingTop: 0,
                }}
              >
                {heading === 'cement'
                  ? item.totalCementSub != null
                    ? item.totalCementSub
                    : '-'
                  : heading === 'sand'
                    ? item.totalSandSub != null
                      ? item.totalSandSub
                      : '-'
                    : heading === 'gravel815'
                      ? item.totalGravel815Sub != null
                        ? item.totalGravel815Sub
                        : '-'
                      : item.totalGrave1525Sub != null
                        ? item.totalGrave1525Sub
                        : '-'}
              </td>
              <td
                style={{
                  border: '0.3mm solid black',
                  paddingBottom: '1mm',
                  paddingTop: 0,
                }}
              >
                {heading === 'cement'
                  ? item.cementEod != null
                    ? item.cementEod
                    : '-'
                  : heading === 'sand'
                    ? item.sandEod != null
                      ? item.sandEod
                      : '-'
                    : heading === 'gravel815'
                      ? item.gravel815Eod != null
                        ? item.gravel815Eod
                        : '-'
                      : item.gravel1525Eod != null
                        ? item.gravel1525Eod
                        : '-'}
              </td>
            </tr>
          );
        })}
        {typeof total.totalSub === 'number' && (
          <>
            <tr style={{ height: '7mm', backgroundColor: '#d4d4a4' }}>
              <td
                style={{
                  border: '0.3mm solid black',
                  paddingBottom: '2.7mm',
                  paddingTop: 0,
                  fontWeight: '600',
                }}
                colSpan={1}
              >
                {total.totalAdd}
              </td>
              <td
                style={{
                  border: '0.3mm solid black',
                  paddingBottom: '2.7mm',
                  paddingTop: 0,
                  fontWeight: '600',
                }}
                colSpan={2}
              >
                {total.totalSub.toFixed(2)}
              </td>
              {/* <td
                style={{
                  border: '0.3mm solid black',
                  paddingBottom: '2.7mm',
                  paddingTop: 0,
                  fontWeight: '600',
                }}
              >
                {' '}
              </td> */}
            </tr>
            <tr
              style={{
                backgroundColor: '#0053a6',
                color: 'white',
                height: '8mm',
              }}
            >
              <td
                colSpan={2}
                style={{
                  border: '0.3mm solid black',
                  paddingBottom: '2.7mm',
                  paddingTop: 0,
                  fontSize: '0.8rem',
                }}
              >
                {t('inventoryPage.stockLeft')}
              </td>
              <td
                style={{
                  border: '0.3mm solid black',
                  paddingBottom: '2.7mm',
                  paddingTop: 0,
                }}
              >
                {total.totalAdd - total.totalSub}
              </td>
            </tr>
          </>
        )}
      </tbody>
    </table>
  );
};

export default Invoice3Table2;
